// src/firebase-config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { 
  collection, 
  doc, 
  setDoc, 
  getDoc,
  deleteDoc, 
  onSnapshot, 
  getDocs, 
  addDoc,
  updateDoc,
  query,
  where,
  orderBy,
  limit
} from 'firebase/firestore'; 

const firebaseConfig = {
    apiKey: "AIzaSyAmBkIvanX3xcEjS3wfv8lB8LWKsxdeQRM",
    authDomain: "solagrace-defcf.firebaseapp.com",
    projectId: "solagrace-defcf",
    storageBucket: "solagrace-defcf.firebasestorage.app",
    messagingSenderId: "688560637655",
    appId: "1:688560657655:web:a468a769b53ad153fed292",
    measurementId: "G-8YHV1X9FPX"
};

const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export { 
  collection, 
  doc, 
  setDoc,
  getDoc,
  deleteDoc, 
  updateDoc,
  onSnapshot, 
  getDocs, 
  addDoc, 
  query,
  where,
  orderBy,
  limit
};